import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'toast-specs',
  templateUrl: './toast-specs.component.html',
  styleUrls: ['./toast-specs.component.sass']
})
export class ToastSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/toast/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
